import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    appTitle: 'NMC Election Results 2025-26',
    dashboard: 'Dashboard',
    pollingPercentage: 'Polling Percentage',
    electedCandidates: 'Elected Candidates',
    partywiseVoting: 'Party-wise Voting',
    seatsWon: 'Seats Won',
    materialsUsed: 'Materials Used',
    populationReservation: 'Population & Reservation',
    login: 'Login',
    logout: 'Logout',
    totalVoters: 'Total Voters',
    totalSeats: 'Total Seats',
    pollingStations: 'Polling Stations',
    avgPolling: 'Avg Polling %',
    zone: 'Zone',
    ward: 'Ward',
    party: 'Party',
    candidate: 'Candidate',
    votes: 'Votes',
    search: 'Search',
    filter: 'Filter',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    add: 'Add New',
    password: 'Password',
    adminLogin: 'Admin Login',
    enterPassword: 'Enter admin password',
    winner: 'Winner',
    runnerUp: 'Runner Up',
    margin: 'Margin',
    reservation: 'Reservation',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    total: 'Total',
    percentage: 'Percentage',
    loading: 'Loading...',
    noData: 'No data available',
    error: 'Error loading data'
  },
  mr: {
    appTitle: 'NMC निवडणूक निकाल 2025-26',
    dashboard: 'डॅशबोर्ड',
    pollingPercentage: 'मतदान टक्केवारी',
    electedCandidates: 'निवडून आलेले उमेदवार',
    partywiseVoting: 'पक्षनिहाय मतदान',
    seatsWon: 'जिंकलेल्या जागा',
    materialsUsed: 'वापरलेली साहित्ये',
    populationReservation: 'लोकसंख्या आणि आरक्षण',
    login: 'लॉगिन',
    logout: 'बाहेर पडा',
    totalVoters: 'एकूण मतदार',
    totalSeats: 'एकूण जागा',
    pollingStations: 'मतदान केंद्रे',
    avgPolling: 'सरासरी मतदान %',
    zone: 'झोन',
    ward: 'प्रभाग',
    party: 'पक्ष',
    candidate: 'उमेदवार',
    votes: 'मते',
    search: 'शोधा',
    filter: 'फिल्टर',
    edit: 'संपादित करा',
    save: 'जतन करा',
    cancel: 'रद्द करा',
    delete: 'हटवा',
    add: 'नवीन जोडा',
    password: 'पासवर्ड',
    adminLogin: 'प्रशासक लॉगिन',
    enterPassword: 'प्रशासक पासवर्ड प्रविष्ट करा',
    winner: 'विजेता',
    runnerUp: 'उपविजेता',
    margin: 'फरक',
    reservation: 'आरक्षण',
    male: 'पुरुष',
    female: 'महिला',
    other: 'इतर',
    total: 'एकूण',
    percentage: 'टक्केवारी',
    loading: 'लोड होत आहे...',
    noData: 'डेटा उपलब्ध नाही',
    error: 'डेटा लोड करताना त्रुटी'
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'mr' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};